var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimezone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1739_37557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7817 12.5C10.3437 12.5 7.56348 9.82374 7.56348 6.51439C7.56348 3.20504 10.3437 0.5 13.7817 0.5C17.2197 0.5 20 3.17626 20 6.48561C20 9.79496 17.2197 12.5 13.7817 12.5ZM13.7817 1.65108C11.0014 1.65108 8.75929 3.80935 8.75929 6.48561C8.75929 9.16187 11.0014 11.3201 13.7817 11.3201C16.562 11.3201 18.8041 9.16187 18.8041 6.48561C18.8041 3.80935 16.562 1.65108 13.7817 1.65108Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4724 8.41365L13.2437 6.83092V2.4856H14.4395V6.14027L17.0105 7.37768L16.4724 8.41365Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5708 7.06113V5.91006H5.1418V2.4856H6.33762V7.06113H2.5708Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77279 11.0899C7.29447 11.2338 6.75635 11.3201 6.21824 11.3201C3.43797 11.3489 1.19581 9.16187 1.19581 6.48561C1.19581 3.80935 3.43797 1.65108 6.21824 1.65108C6.75635 1.65108 7.26457 1.73741 7.77279 1.88129C8.04185 1.56475 8.34081 1.2482 8.66966 0.960432C7.92227 0.672662 7.0852 0.5 6.21824 0.5C2.78027 0.5 0 3.17626 0 6.48561C0 9.79496 2.78027 12.4712 6.21824 12.4712C7.0852 12.4712 7.89238 12.2986 8.63976 11.982C8.34081 11.723 8.04185 11.4353 7.77279 11.0899Z",
    fill: "#EE8B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1739_37557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/timezone.3470a8c0c796750222e8e2a41fc763e2.svg";
export { ForwardRef as ReactComponent };